import ExcelJS from 'exceljs';
import { ContractingType } from 'v3/data/store/contracting/types';
import * as api from 'v3/services/api';
import { FeatureFlagEnum } from 'v3/shared/enums/feature-flag.enum';
const NUMBER_MAX_ROW = 100

export const excelFormatterForSellers = async (list) => {
  const fetchSellerFeatureFlag = async () => {
    const response = await api.getFlagStatus(FeatureFlagEnum.IKCLOUD_12852_SELLER_BANK_ACCOUNT_BACKOFFICE);
    return response?.data?.enabled;
  };
  const sellerBankAccountFeature = await fetchSellerFeatureFlag();

  const file = await createExcel(list, sellerBankAccountFeature);
  let url = window.URL.createObjectURL(file);
  let a = document.createElement('a');
  a.href = url;
  a.download = 'vendedores-dimo-financiamento.xlsx';
  a.click();
};

const orderWorksheetFactory = (
  workbook: ExcelJS.Workbook,
  worksheetName: string,
  sellerBankAccountFeature: boolean,
) => {
  const worksheet = workbook.addWorksheet(worksheetName);

  const columns: Partial<ExcelJS.Column>[] = [
    { header: 'Nome', key: 'name', width: 30 },
    { header: 'CPF', key: 'cpf', width: 18 },
  ];

  if (sellerBankAccountFeature) {
    columns.push(
      { header: 'Email', key: 'email', width: 35 },
      { header: 'Telefone', key: 'phoneNumber', width: 20 },
      { header: 'Cargo', key: 'role', width: 20 },
      { header: 'Chave Pix *', key: 'pixKey', width: 30 },
    );
  }

  worksheet.columns = columns as ExcelJS.Column[];

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
  });

  return worksheet;
};

const createExcel = async (orders: ContractingType[], sellerBankAccountFeature: boolean) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = orderWorksheetFactory(workbook, 'Relatório', sellerBankAccountFeature);
  worksheet.columns.forEach((column) => {
  column.alignment = { horizontal: 'left' }
  column.numFmt = '@'
  ;
});

  if (sellerBankAccountFeature) {
    const roles = ['Consultor', 'Gerente', 'Sub-Gerente'];
    
    for (let row = 2; row <= NUMBER_MAX_ROW; row++) {
      const cell = worksheet.getCell(`E${row}`);

      cell.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`"${roles.join(',')}"`],
        showErrorMessage: true,
        errorTitle: 'Valor inválido',
        error: 'Selecione um cargo válido da lista',
      };
    }
  }
  

  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const file = new Blob([buffer], { type: fileType });

  return file;
};